<section class="l-reset">
  <div class="reset">
    <a routerLink="/auth" class="reset-backLink login-header-backLink">
      {{ "Go back" | translate }}

      <img src="/assets/images/login/header-back-btn.png" alt="" class="icon" />
    </a>

    <div class="reset-body">
      <div class="reset-cover">
        <img src="/assets/images/login/reset-bg.png" alt="" class="image" />
      </div>
      <h2 class="reset-title">
        {{ "Enter the verification code" | translate }}
      </h2>
      <p class="reset-desc">
        {{
          "Please enter the verification code sent to your mobile" | translate
        }}
      </p>

      <div class="form-group mb-4">
        <ng-otp-input
          [formCtrl]="code"
          [config]="{ length: 4 }"
        ></ng-otp-input>
      </div>

      <button
        type="button"
        [disabled]="code.value.length !== 4"
        (click)="verifyCode()"
        class="btn btn-primary w-100 mb-3"
      >
        {{ "Verify" | translate }}
      </button>
      <p class="reset-desc mb-3 clickable" >
        <a href="#" (click)="$event.preventDefault();resendActivationCode()">{{ "Resend activation code" | translate }}</a>
      </p>
    </div>
  </div>
</section>
